import React from "react";

export default function StepDesiredOutcome({ onNext, onBack, formData }) {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">What is your desired outcome?</h2>
      <input
        className="w-full p-2 border rounded mb-4"
        type="text"
        placeholder="Describe your desired outcome"
        defaultValue={formData?.desiredOutcome || ""}
        onChange={e => formData.desiredOutcome = e.target.value}
      />
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button
          className="btn btn-primary"
          onClick={() => onNext({ desiredOutcome: formData.desiredOutcome })}
        >
          Next
        </button>
      </div>
    </div>
  );
}